import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experiments from '../../experiments.yaml';
export const laboratoryClient = createClient({
  identifiers: {
    portalId: PortalIdParser.get()
  },
  experiments: experiments,
  name: 'experiment-instance'
});
export const logExposure = experimentKey => {
  return laboratoryClient.logExposure(experimentKey);
};